import { render } from "./StaySummary.vue?vue&type=template&id=f20aa034"
import script from "./StaySummary.vue?vue&type=script&lang=js"
export * from "./StaySummary.vue?vue&type=script&lang=js"

import "@/shared/css/summary.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__